import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ManagedImage, SortableImageUploader } from "@/components/desk/SortableImageUploader";

interface PropertyMediaSidebarProps {
  propertyId?: number;
  images?: ManagedImage[];
}

export default function PropertyMediaSidebar({
  propertyId,
  images = [],
}: PropertyMediaSidebarProps) {
  if (!propertyId) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>الصور</CardTitle>
          <CardDescription>احفظ العقار أولاً لإدارة الصور</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          ستظهر أداة رفع الصور هنا بعد حفظ العقار. يمكنك بعدها رفع الصور وترتيبها.
        </CardContent>
      </Card>
    );
  }

  const basePath = `/desk/properties/${propertyId}`;

  return (
    <SortableImageUploader
      title="الصور"
      description="حمل الصور وقم بإعادة ترتيبها حسب الحاجة"
      images={images}
      uploadPath={`${basePath}/images`}
      reorderPath={`${basePath}/images/reorder`}
      deletePath={(imageId) => `${basePath}/images/${imageId}`}
    />
  );
}
